import { differenceInHours, differenceInMinutes, max, min } from "date-fns";

export default function validate(data) {
    let errors = {};

    // Validation for pickup address when template uses "от двери" mode
    if ( (data.selected_mode == 1 || data.selected_mode == 2) && !data.addressFrom) {
        errors.addressFrom = 'from_address_error';
    }

    return errors
}